import { createFileRoute } from '@tanstack/react-router';

import { MeetingTelemetryDetailPage } from '@/pages/super-admin/meeting-telemetry/MeetingTelemetryDetailPage';

export const Route = createFileRoute('/_authenticated/super-admin/meeting-telemetry/$meetingId')({
	component: MeetingTelemetryDetailRoute,
});

function MeetingTelemetryDetailRoute() {
	const { meetingId } = Route.useParams();
	return <MeetingTelemetryDetailPage meetingId={meetingId} />;
}
